<!-- รายงานหลักสูตรทั้งหมดของอาจารย์ -->

<app-card [hidHeader]="true" cardClass="tab-card" blockClass="nav-fill">
    <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
            <div class="row">
                <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12">
                    <app-card cardClass="table-card" [hidHeader]="true">
                        <div class="row"
                            style="padding-top: 20px;padding-left: 10px;justify-content: space-between;display: flex;margin: unset;">
                            <h6>{{'EXECUTIVE.ALL-COURSES' | translate}}</h6>
                            <!-- <button type="button" class="btn custom-excel-button" data-toggle="tooltip"
                                data-placement="bottom" title="{{'EXECUTIVE.DOWNLOAD-ALL-COURSES' | translate}}"
                                style="margin-bottom: 10px;margin-right: 5px;" (click)="exportexcel('Subject-All')">
                                <i class="icon feather icon-download f-16 text-c-black"></i>
                                {{'EXECUTIVE.DOWNLOAD-EXCEL'
                                | translate}}
                            </button> -->
                        </div>
                        <div *ngIf="reportSubjectAll != null" style="height: 416px;">
                            <perfect-scrollbar
                                style="background-color: white; border-radius: 5px; height: 439px; top: 0px;">
                                <div *ngFor="let Subject of reportSubjectAll;index as i"
                                    (click)="onSelectSubject(Subject.subjectId)" style="cursor: pointer;">
                                    <p class="custom-text">
                                        <span>
                                            {{i+1}}. {{Subject.nameTh}}
                                        </span>
                                    </p>
                                </div>
                            </perfect-scrollbar>
                        </div>
                        <div style="text-align: center;margin: 20px;">
                            <div class="spinner-border text-info" role="status" *ngIf="dataLoading1">
                                <span class="sr-only">{{'EXECUTIVE.LOADING' | translate}}...</span>
                            </div>
                        </div>
                        <p *ngIf="!dataLoading1 && reportSubjectAll == null "
                            style="text-align: center;padding-top: 10px;">
                            <b>*{{'EXECUTIVE.NO-DATA' | translate}}</b>
                        </p>
                    </app-card>
                </div>

                <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12" style="padding-left: unset;">
                    <div class="row">
                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                            <app-card [hidHeader]="true">
                                <div class="row"
                                    style="padding-bottom: 10px;margin: unset;justify-content: space-between;display: flex;">
                                    <h6 style="margin-bottom: unset;align-self: center;">
                                        รายงานจำนวนการเข้าใช้งานของผู้เรียน </h6>
                                    <!-- แสดง ข้อมูลบทเรียน ให้เลือก -->
                                    <ng-select [ngClass]="'ng-select'" [(ngModel)]="selectedLesson"
                                        [options]="dataFindLesson" style="width: 400px;margin-right: 10px;"
                                        (ngModelChange)="onSelectLesson($event)">
                                        <ng-template let-option="dataFindLesson">
                                            {{dataFindLesson.label}}
                                        </ng-template>
                                    </ng-select>
                                </div>
                                <div class="card" style="cursor: pointer;"
                                    (click)="openDataStudyingList(studyingCount)">
                                    <div class="card-body" style="padding: 10px;">
                                        <h6 class="card-title bg-gradient">รายงานจำนวนผู้เรียนทั้งหมด</h6>
                                        <div class="row" style="justify-content: space-around;">
                                            <h6 class="card-text">รายงานจำนวนผู้เรียน
                                                <h4 class="text-center">{{studyingCount? studyingCount.length:0}}
                                                </h4>
                                            </h6>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-body" style="padding: 10px;"
                                        >
                                        <h6 class="card-title bg-gradient">รายงานจำนวนการเข้าใช้งานของผู้เรียน</h6>
                                        <div class="row" style="justify-content: space-around;">
                                            <div class="" style="padding: 10px; cursor: pointer;" (click)="openDataStudyingCountList2(this.reportstudyList)">
                                                <h6 class="card-text">เข้าเรียนวันนี้
                                                    <h4 class="text-center">{{studentLearnLesson?
                                                        studentLearnLesson.countListSudentLearnToDay:0}}</h4>
                                                </h6>
                                            </div>
                                            <div class="" style="padding: 10px; cursor: pointer;" (click)="openDataStudyingCountList(this.reportstudyList)">
                                                <h6 class="card-text">เข้าเรียนแล้ว
                                                    <h4 class="text-center">{{studentLearnLesson?
                                                        studentLearnLesson.countListAll:0}}</h4>
                                                </h6>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </app-card>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- รายงานข้อมูลผู้เรียน สถานะ  "กำลังเรียน"  ตามรายหลักสูตร -->
        <app-ui-modal #myCountStudentStudying [hideFooter]="true" [dialogClass]="'modal-xl'">
            <div class="app-modal-header">
                <h6 class="modal-title">{{'EXECUTIVE.ALL-LEARNERS' | translate}}</h6>
                <button type="button" class="close basic-close" data-dismiss="modal" aria-label="Close"
                    (click)="myCountStudentStudying.hide()"><span aria-hidden="true">&times;</span></button>
            </div>
            <div class="app-modal-body">
                <div class="row">
                    <!-- <div class="search-barrr">
                        <input type="text" [(ngModel)]="searchModel1" (ngModelChange)="searchChange1($event)"
                            placeholder="{{'TEACHER.Q-AND-A.SEARCH' | translate}}...">
                        <i class="feather icon-search"></i>
                    </div> -->
                    <!-- <app-card [hidHeader]="true" cardClass="user-profile-list" style="margin-top: -30px;"> -->
                    <!-- <button type="button" class="btn custom-excel-button" data-toggle="tooltip" data-placement="bottom"
                        title="{{'EXECUTIVE.DOWNLOAD-ALL-COURSES' | translate}}"
                        style="margin-bottom: 10px;margin-right: 5px;"
                        (click)="exportexcel('Student-Information-Report')">
                        <i class="icon feather icon-download f-16 text-c-black"></i> {{'EXECUTIVE.DOWNLOAD-EXCEL'
                        | translate}} รายงานข้อมูลผู้เรียน
                    </button> -->
                </div>

                <div class="table-scroll-x" style="height: 500px;overflow-x: hidden;"
                    *ngIf="studyingList != null && studyingList != '' && studyingList != undefined ">
                    <table class="table-version-z" *ngIf="!dataLoading1">
                        <thead>
                            <tr>
                                <th class="first">{{'EXECUTIVE.ARRANGE' | translate}}</th>
                                <th class="text-center">{{'EXECUTIVE.NAME' | translate}}</th>
                                <!-- <th class="text-center">{{'EXECUTIVE.E-MAIL' | translate}}</th> -->
                                <th class="text-center">{{'EXECUTIVE.PHONE-NUMBER' | translate}}</th>
                                <th class="text-center">{{'EXECUTIVE.DATE-OF-BIRTH' | translate}}</th>
                                <!-- <th class="last">{{'EXECUTIVE.MORE-INFORMATION' | translate}}</th> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of studyingList;index as i" [ngClass]="i % 2 == 0 ? 'odd' : 'even'">
                                <td class="text-center">{{i+1}}</td>
                                <td>
                                    <div class="d-inline-block">
                                        <img src="{{urlImage}}{{item.dataStudent.image}}" alt="user image"
                                            class="img-radius  m-r-15"
                                            style="width:40px; height: 40px;object-fit: cover;"
                                            onerror="this.src='assets/images/no-img.png'">
                                        <div class="d-inline-block">
                                            <p class="m-b-0">{{dataLanguage=="th"?
                                                item.dataStudent.fullNameTh:item.dataStudent.fullNameEn}}
                                            </p>
                                            <!-- <p class="m-b-0">{{item.dataStudent.fullNameEn}}</p> -->
                                        </div>
                                    </div>
                                </td>
                                <!-- <td>{{item.dataStudent.email}}</td> -->
                                <td class="text-center" *ngIf="item.dataStudent.phoneNumber != ''">
                                    *******{{item.dataStudent.phoneNumber[7]}}{{item.dataStudent.phoneNumber[8]}}{{item.dataStudent.phoneNumber[9]}}
                                <td *ngIf="item.dataStudent.phoneNumber == ''"> - </td>
                                <!-- <td >{{item.phoneNumber}}</td> -->
                                <td class="text-center">{{item.dataStudent.brithOfDate | date:'fullDate'}}</td>
                                <!-- <td class="text-center">
                                    <span type="button" (click)="openViewStudyingList(item)">
                                        <i class="icon feather icon-eye f-16 text-i-view"></i></span>

                                </td> -->
                            </tr>
                        </tbody>
                    </table>
                    <div style="text-align: center;margin: 20px;">
                        <div class="spinner-border text-info" role="status" *ngIf="dataLoading1">
                            <span class="sr-only">{{'EXECUTIVE.LOADING' | translate}}...</span>
                        </div>
                    </div>
                </div>
                <div *ngIf="pageCount1" class="page-control">

                    <p style="margin-right: 15px;">{{'ADMIN.Q-AND-A.PAGE' | translate}} <span
                            class="ml-1 mr-1">{{page1}}</span>
                        {{'ADMIN.Q-AND-A.OF' |
                        translate}} <span class="ml-1">{{pageCount1}}</span></p>
                    <div>
                        <button (click)="pageChange('prev')" class="prev">{{'ADMIN.Q-AND-A.PREVIOUS' |
                            translate}}</button>
                        <button (click)="pageChange('next')" class="next">{{'ADMIN.Q-AND-A.NEXT' | translate}}</button>
                    </div>
                </div>
                <div *ngIf="studyingList == null || studyingList == '' || studyingList == undefined">
                    No Data
                </div>

                <!-- </app-card> -->
            </div>
            <!-- </app-card> -->
        </app-ui-modal>

        <app-ui-modal #myStudentStudyingList [hideFooter]="true" [dialogClass]="'modal-xl'">
            <div class="app-modal-header">
                <h6 class="modal-title">{{'EXECUTIVE.ALL-LEARNERS' | translate}}</h6>
                <button type="button" class="close basic-close" data-dismiss="modal" aria-label="Close"
                    (click)="myStudentStudyingList.hide()"><span aria-hidden="true">&times;</span></button>
            </div>
            <div class="app-modal-body">
                <div class="row">
                    <!-- <div class="search-barrr">
                        <input type="text" [(ngModel)]="searchModel1" (ngModelChange)="searchChange1($event)"
                            placeholder="{{'TEACHER.Q-AND-A.SEARCH' | translate}}...">
                        <i class="feather icon-search"></i>
                    </div> -->
                    <!-- <app-card [hidHeader]="true" cardClass="user-profile-list" style="margin-top: -30px;"> -->
                    <!-- <button type="button" class="btn custom-excel-button" data-toggle="tooltip" data-placement="bottom"
                        title="{{'EXECUTIVE.DOWNLOAD-ALL-COURSES' | translate}}"
                        style="margin-bottom: 10px;margin-right: 5px;"
                        (click)="exportexcel('Student-Information-Report')">
                        <i class="icon feather icon-download f-16 text-c-black"></i> {{'EXECUTIVE.DOWNLOAD-EXCEL'
                        | translate}} รายงานข้อมูลผู้เรียน
                    </button> -->
                </div>
                <div style="margin-left: 15px; margin-top: 1rem; margin-bottom: 1rem;">
                    <p>รายชื่อผู้เข้าเรียนแล้ว</p>
                </div>
                <div class="table-scroll-x" style="height: 280px;overflow-x: hidden;"
                    *ngIf="studySuccesList != null && studySuccesList != '' && studySuccesList != undefined ">
                    <table class="table-version-z" *ngIf="!dataLoading1">
                        <thead>
                            <tr>
                                <th class="first">{{'EXECUTIVE.ARRANGE' | translate}}</th>
                                <th class="text-center">{{'EXECUTIVE.NAME' | translate}}</th>
                                <th class="text-center">{{'EXECUTIVE.LESSON-START-DATE' | translate}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of studySuccesList;index as i" [ngClass]="i % 2 == 0 ? 'odd' : 'even'">
                                <td class="text-center">{{i+1}}</td>
                                <td>
                                    <div class="d-inline-block">
                                        <img src="{{urlImage}}{{item.image}}" alt="user image"
                                            class="img-radius  m-r-15"
                                            style="width:40px; height: 40px;object-fit: cover;"
                                            onerror="this.src='assets/images/no-img.png'">
                                        <div class="d-inline-block">
                                            <p class="m-b-0">{{dataLanguage=="th"?
                                                item.fullNameTh:item.fullNameEn}}
                                            </p>
                                        </div>
                                    </div>
                                </td>
                                <td class="text-center">
                                    {{ item.lessonStartDate ? (item.lessonStartDate | date:'fullDate') :
                                    'ยังไม่ได้เข้าเรียน' }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div style="text-align: center;margin: 20px;">
                        <div class="spinner-border text-info" role="status" *ngIf="dataLoading1">
                            <span class="sr-only">{{'EXECUTIVE.LOADING' | translate}}...</span>
                        </div>
                    </div>
                </div>
                <div *ngIf="pageCount1" class="page-control">
                    <p style="margin-right: 15px;">{{'ADMIN.Q-AND-A.PAGE' | translate}} <span
                            class="ml-1 mr-1">{{page1}}</span>
                        {{'ADMIN.Q-AND-A.OF' |
                        translate}} <span class="ml-1">{{pageCount1}}</span></p>
                    <div>
                        <button (click)="pageChange1('prev')" class="prev">{{'ADMIN.Q-AND-A.PREVIOUS' |
                            translate}}</button>
                        <button (click)="pageChange1('next')" class="next">{{'ADMIN.Q-AND-A.NEXT' | translate}}</button>
                    </div>
                </div>
                <div *ngIf="studySuccesList == null || studySuccesList == '' || studySuccesList == undefined">
                    <table class="table-version-z" *ngIf="!dataLoading1">
                        <thead>
                            <tr>
                                <th class="first">{{'EXECUTIVE.ARRANGE' | translate}}</th>
                                <th class="text-center">{{'EXECUTIVE.NAME' | translate}}</th>
                                <th class="text-center">{{'EXECUTIVE.LESSON-START-DATE' | translate}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <div class="d-inline-block">
                                        <div class="d-inline-block">
                                            <p class="text-center m-b-0">No Data.
                                            </p>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>
        </app-ui-modal>

        <app-ui-modal #myStudentStudyingList2 [hideFooter]="true" [dialogClass]="'modal-xl'">
            <div class="app-modal-header">
                <h6 class="modal-title">{{'EXECUTIVE.ALL-LEARNERS' | translate}}</h6>
                <button type="button" class="close basic-close" data-dismiss="modal" aria-label="Close"
                    (click)="myStudentStudyingList2.hide()"><span aria-hidden="true">&times;</span></button>
            </div>
            <div class="app-modal-body">
                <div class="row">
                    <!-- <div class="search-barrr">
                        <input type="text" [(ngModel)]="searchModel1" (ngModelChange)="searchChange1($event)"
                            placeholder="{{'TEACHER.Q-AND-A.SEARCH' | translate}}...">
                        <i class="feather icon-search"></i>
                    </div> -->
                    <!-- <app-card [hidHeader]="true" cardClass="user-profile-list" style="margin-top: -30px;"> -->
                    <!-- <button type="button" class="btn custom-excel-button" data-toggle="tooltip" data-placement="bottom"
                        title="{{'EXECUTIVE.DOWNLOAD-ALL-COURSES' | translate}}"
                        style="margin-bottom: 10px;margin-right: 5px;"
                        (click)="exportexcel('Student-Information-Report')">
                        <i class="icon feather icon-download f-16 text-c-black"></i> {{'EXECUTIVE.DOWNLOAD-EXCEL'
                        | translate}} รายงานข้อมูลผู้เรียน
                    </button> -->
                </div>
                <div style="margin-left: 15px; margin-top: 1rem; margin-bottom: 1rem;">
                    <p>รายชื่อผู้เข้าเรียนวันนี้</p>
                </div>
                <div class="table-scroll-x" style="height: 280px;overflow-x: hidden;"
                    *ngIf="studyingToDayList != null && studyingToDayList != '' && studyingToDayList != undefined ">
                    <table class="table-version-z" *ngIf="!dataLoading1">
                        <thead>
                            <tr>
                                <th class="first">{{'EXECUTIVE.ARRANGE' | translate}}</th>
                                <th class="text-center">{{'EXECUTIVE.NAME' | translate}}</th>
                                <th class="text-center">{{'EXECUTIVE.LESSON-START-DATE' | translate}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of studyingToDayList;index as i"
                                [ngClass]="i % 2 == 0 ? 'odd' : 'even'">
                                <td class="text-center">{{i+1}}</td>
                                <td>
                                    <div class="d-inline-block">
                                        <img src="{{urlImage}}{{item.image}}" alt="user image"
                                            class="img-radius  m-r-15"
                                            style="width:40px; height: 40px;object-fit: cover;"
                                            onerror="this.src='assets/images/no-img.png'">
                                        <div class="d-inline-block">
                                            <p class="m-b-0">{{dataLanguage=="th"?
                                                item.fullNameTh:item.fullNameEn}}
                                            </p>
                                            <!-- <p class="m-b-0">{{item.dataStudent.fullNameEn}}</p> -->
                                        </div>
                                    </div>
                                </td>
                                <td class="text-center">{{ item.lessonStartDate ? (item.lessonStartDate |
                                    date:'fullDate') : 'ยังไม่ได้เข้าเรียน' }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <div style="text-align: center;margin: 20px;">
                        <div class="spinner-border text-info" role="status" *ngIf="dataLoading1">
                            <span class="sr-only">{{'EXECUTIVE.LOADING' | translate}}...</span>
                        </div>
                    </div>
                </div>
                <div *ngIf="pageCount2" class="page-control">

                    <p style="margin-right: 15px;">{{'ADMIN.Q-AND-A.PAGE' | translate}} <span
                            class="ml-1 mr-1">{{page2}}</span>
                        {{'ADMIN.Q-AND-A.OF' |
                        translate}} <span class="ml-1">{{pageCount2}}</span></p>
                    <div>
                        <button (click)="pageChange2('prev')" class="prev">{{'ADMIN.Q-AND-A.PREVIOUS' |
                            translate}}</button>
                        <button (click)="pageChange2('next')" class="next">{{'ADMIN.Q-AND-A.NEXT' | translate}}</button>
                    </div>
                </div>
                <div *ngIf="studyingToDayList == null || studyingToDayList == '' || studyingToDayList == undefined">
                    <table class="table-version-z" *ngIf="!dataLoading1">
                        <thead>
                            <tr>
                                <th class="first">{{'EXECUTIVE.ARRANGE' | translate}}</th>
                                <th class="text-center">{{'EXECUTIVE.NAME' | translate}}</th>
                                <th class="text-center">{{'EXECUTIVE.LESSON-START-DATE' | translate}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <div class="d-inline-block">
                                        <div class="d-inline-block">
                                            <p class="text-center m-b-0">No Data.
                                            </p>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- </app-card> -->
            </div>
        </app-ui-modal>

    </div>
</app-card>